import $ from 'jquery';

export const hideIntercom = () => {
  // eslint-disable-next-line no-jquery/no-jquery-constructor,no-jquery/no-visibility
  $('#help-widget').hide();
};

export const showIntercom = () => {
  // eslint-disable-next-line no-jquery/no-jquery-constructor,no-jquery/no-visibility
  $('#help-widget').show();
};

export const clickIntercom = () => {
  // eslint-disable-next-line no-jquery/no-jquery-constructor,no-jquery/no-trigger
  $('#help-widget').trigger('click');
};

// eslint-disable-next-line no-jquery/no-jquery-constructor,no-jquery/no-is
export const isIntercomVisible = () => $('#help-widget').is(':visible');

export const playVideo = (tour) => Intercom('startTour', tour);
